import ExtjsReact from "../../utils/ExtReact";
import clone from "lodash/cloneDeep";

class ExtjsCriteriaPanel extends ExtjsReact {
  renderExtjsCmp() {
    let me = this;
    setTimeout(
      () => {
        me.getCriteriaPanel(this.renderTo);
        if (typeof me.props.value == "object") {
          me.cmp.setValue(
            me.props.value.query_string,
            me.props.value.query_tree
          );
        } else {
          me.cmp.setValue(me.props.value || "");
        }
      },
      me.props.delayedRender ? 300 : 0
    );
  }

  getCriteriaPanel = (renderTo) => {
    var me = this,
      props = me.props;
    // currentSheetColumns = TL.list.settings.lookup.CriteriaHelper.formatColumns(clone(viewPort.currentListColumns), {
    //   listNameStr:  this.props.currentSheetName //viewPort.currentList.name
    // });
    props.lookupColumns?.forEach((col) => (col.alias_name = col.alias_path));
    props.currentSheetColumns?.forEach(
      (col) => (col.alias_name = col.alias_path)
    );
    return (me.cmp = Ext.create("TL.list.settings.lookup.CriteriaPanel", {
      renderTo: renderTo,
      border: false,
      autoScroll: true,
      itemId: "criteria",
      lookupColumns: props.lookupColumns || [],
      currentListId: props.currentListId,
      lookupListId: props.lookupListId,
      currentSheetColumns: props.currentSheetColumns || [],
      hiddenFilterTitle: props.hiddenFilterTitle ?? true,
      hiddenMultiLevels: props.hiddenMultiLevels ?? true,
      initWithCriteria: props.initWithCriteria ?? true,
      filtersHidden: props.filtersHidden ?? false,
      listeners: {
        criteriachange: me.props.onChange || (() => {}),
      },
    }));
  };

  getValue = () => this.cmp.getValue();
}

export default ExtjsCriteriaPanel;
